/**
 * Define the Action and Subject (using model) for the permissions in the system
 */
import { Ability, AbilityBuilder } from '@casl/ability';
export const LumiereAbility = Ability;
const { can } = new AbilityBuilder(Ability);
